import React from 'react';
import ReactDOM from 'react-dom/client'; 
// Importa i componenti fondamentali di Chakra UI
import { ChakraProvider, extendTheme } from '@chakra-ui/react'; 
import App from './App'; 

// 1. Estendi o definisci il tuo tema. 
// Ho aggiunto alcuni degli shade 'indigo' che hai usato nei tuoi file.
const theme = extendTheme({
    colors: {
      indigo: {
        50: '#eef2ff',
        100: '#e0e7ff',
        200: '#c7d2fe',
        300: '#a5b4fc',
        400: '#818cf8',
        500: '#6366f1',
        600: '#4f46e5',
        700: '#4338ca',
        800: '#3730a3',
        900: '#312e81',
      },
    },
    // Puoi aggiungere qui altre personalizzazioni: font, breakpoint, ecc.
});

// Usa createRoot per React 18/19
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    {/* 2. Wrappa l'applicazione e passa il tema */}
    <ChakraProvider theme={theme}>
      <App />
    </ChakraProvider>
  </React.StrictMode>
);